<template>
    <div id="app">
        <Navigation></Navigation>
        <!--
        <Navigationbrewer v-if="userProfile&&userProfile.isbrewer == '1'||userProfile&&userProfile.isbrewer == '2'"></Navigationbrewer>
        <Navigation v-if="userProfile&&userProfile.isbrewer == '0'"></Navigation>
        <Navigationrep v-if="userProfile&&userProfile.isbrewer == '10'"></Navigationrep>
        -->
    	<router-view/>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import Navigation from './components/Navigation.vue'
    import Navigationbrewer from './components/Navigationbrewer.vue'
    import Navigationrep from './components/Navigationrep.vue'

    export default {
        components: { Navigation,Navigationbrewer, Navigationrep },
        computed: {
            ...mapState(['currentUser', 'userProfile', 'selectedConsumerWebsite'])
        },
        mounted(){
            //window.open("http://localhost:8081/");  
        }
    }
</script>
